import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';

@Component({
  selector: 'app-nuovo-flusso',
  templateUrl: './nuovo-flusso.component.html',
  styleUrls: ['./nuovo-flusso.component.css']
})
export class NuovoFlussoComponent implements OnInit {

	@Input() saved: boolean = false;
	@Input() writePermission: boolean = false;

	@Output() innerEvents = new EventEmitter();

	newFlow: any = {
		name : '',
		description : ''
	}

	constructor() {}

	ngOnInit() {}

	hide(){
		let event:any = {
			hide : true
		}
		this.innerEvents.emit(event);
	}

	discard() {
		this.hide();
	}

	makeNew() {
		let event:any = {
			hide : true,
			flowEvent : true,
			data : {
				type : 'makeNew',
				content : this.newFlow
			}
		}
		this.innerEvents.emit(event);
	}

	safeSave() {
		let event:any = {
			hide : true,
			flowEvent : true,
			data : {
				type : 'safeSave'
			}
		}
		this.innerEvents.emit(event);
	}

}
